import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a numeric value using the en-US locale.
 * - Supports numbers and numeric strings
 * - Returns empty string for null/undefined
 * - Returns original value if conversion fails
 */
@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

  /**
   * Transforms a value into a formatted number string
   * @param value Input value (number or numeric string)
   * @returns Formatted number string or original value
   */
  transform(value: unknown, ...args: unknown[]): unknown {

    // Return empty string for null or undefined inputs
    if (value === null || value === undefined) {
      return '';
    }

    // Convert value to number if needed
    const num = typeof value === 'number' ? value : Number(value);

    // If conversion fails, return original value
    if (isNaN(num)) {
      return value;
    }

    // Format number using US locale with up to 2 decimal places
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(num);
  }

}
